'use strict';

/* Components */
import NavbarComponent from '../components/navbar/navbar.component';
import AccountRequestComponent from '../components/account-request/account-request.component';
import AccountRequestButton from '../components/account-request-button/account-request-button.component';
import html5vfixDirective from '../components/html5vfix/html5vfix.directive';
import ContactFormComponent from '../components/contact-form/contact-form.component';

import PostInfoComponent from '../components/post-info/post-info.component';
import PostSummaryComponent from '../components/post-summary/PostSummary.component';

import NewsFeedComponent from '../components/news-feed/news-feed.component';
import PublicNewsFeedComponent from '../components/public-news-feed/public-news-feed.component';

import VideoPlayerComponent from '../components/video-player/video-player.component';

import 'videogular/dist/videogular/videogular.min';
import 'videogular/dist/controls/vg-controls.min';
import 'videogular-themes-default/videogular.min.css';

import '../components/weather/jquery.simplerWeather';

import IFrameWidgetComponent from '../components/sidebar/iframe-widget/iframe-widget.component';
import PayFeesOnlineWidgetComponent from '../components/sidebar/pay-fees-online-widget/pay-fees-online-widget.component';
import PiperExpectedTodayWidgetComponent from '../components/sidebar/piper-expected-today-widget/piper-expected-today-widget.component';
import PiperUpcomingGuestsWidgetComponent from '../components/sidebar/piper-upcoming-guests-widget/piper-upcoming-guests-widget.component';
import CalendarWidgetComponent from '../components/sidebar/calendar-widget/calendar-widget.component';
import ContactWidgetComponent from '../components/sidebar/contact-widget/contact-widget.component';
import DocumentsWidgetComponent from '../components/sidebar/documents-widget/documents-widget.component';
import BulletinsWidgetComponent from '../components/sidebar/bulletins-widget/bulletins-widget.component';
import GalleriesWidgetComponent from '../components/sidebar/galleries-widget/galleries-widget.component';
import NewsWidgetComponent from '../components/sidebar/news-widget/news-widget.component';
import ReservationWidgetComponent from '../components/sidebar/reservation-widget/reservation-widget.component';

import SectionHeaderComponent from '../components/section-header/section-header.component';
import WeatherWidgetComponent from '../components/sidebar/weather-widget/weather-widget.component';
import WeatherForecastWidgetComponent from '../components/sidebar/weather-forecast-widget/weather-forecast-widget.component';

import WeatherForecastDirective from '../components/weather/weather-forecast.directive';

import usPhoneFilter from '../components/us-phone-filter/us-phone.filter';

import menuEntryEditComponent from '../components/menu-entry-edit/menu-entry-edit.component';

import codemirrorHtmlFormComponent from '../components/codemirror-html-form/codemirror-html-form.component';

import './clock/angular-clock.min';
import './clock/angular-clock.css';

import CrossFaderDirective from '../components/crossFade/crossFade.directive';

import TabsWidgetComponent from '../components/tabs-widget/tabs-widget.component';
import AccordionWidgetComponent from '../components/accordion-widget/accordion-widget.component';
import TemplateWidgetComponent from '../components/template-widget/template-widget.component';

import NiftyComponents from '../components/nifty';

import './angular-scroll-animate/angular-scroll-animate';

import ModalButtonWidgetComponent from '../components/modal-button-widget/modal-button-widget.component';
import FullcalendarWidgetComponent from '../components/fullcalendar-widget/fullcalendar-widget.component';

import AutocompleteRedirectComponent from '../components/autocomplete-redirect/autocomplete-redirect.component';

import ConnectedSiteContentWidget from '../components/sidebar/connected-site-content-widget/connected-site-content-widget.component';

import GoogleReviewsComponent from '../components/google-reviews/google-reviews.component';

import SignatureModal from '../components/signature-modal/signature-modal.component';

import DocumentTreeNodeEditComponent from '../components/document-tree-node-edit/document-tree-node-edit.component';

import ClientErrorsService from '../services/client-errors/client-errors.service';

import ContentSliderDirective from '../components/content-slider/content-slider.directive';

/* Module */
export default angular.module('conduuApp.components', [NavbarComponent, AccountRequestComponent, AccountRequestButton,
  html5vfixDirective, ContactFormComponent, PostInfoComponent, PostSummaryComponent, NewsFeedComponent, VideoPlayerComponent,
  "com.2fdevs.videogular", "com.2fdevs.videogular.plugins.controls", IFrameWidgetComponent, PayFeesOnlineWidgetComponent,
  PiperExpectedTodayWidgetComponent, PiperUpcomingGuestsWidgetComponent, CalendarWidgetComponent, ContactWidgetComponent,
  DocumentsWidgetComponent, BulletinsWidgetComponent, GalleriesWidgetComponent, NewsWidgetComponent, SectionHeaderComponent,
  WeatherWidgetComponent, WeatherForecastWidgetComponent, menuEntryEditComponent, usPhoneFilter, 'ds.clock', CrossFaderDirective,
  codemirrorHtmlFormComponent, TabsWidgetComponent, AccordionWidgetComponent, ReservationWidgetComponent, NiftyComponents,
  'angular-scroll-animate', WeatherForecastDirective, ModalButtonWidgetComponent, FullcalendarWidgetComponent,
  AutocompleteRedirectComponent, TemplateWidgetComponent, ConnectedSiteContentWidget, GoogleReviewsComponent,
  SignatureModal, DocumentTreeNodeEditComponent, PublicNewsFeedComponent, ClientErrorsService, ContentSliderDirective])
.name;



// WEBPACK FOOTER //
// ./client/components/index.js